import React from "react"
import {
    Banner,
    IconWrap,
    Content,
    Actions,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/NextElectionInfo/NextElectionInfo.styles"
import {
    AddToCalendar,
    CalendarEvent,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/AddToCalendar/AddToCalendar"

export interface NextElectionInfoProps {
    electionName: string
    electionDate: string
    calendarEvent?: CalendarEvent
}

export const NextElectionInfo: React.FC<NextElectionInfoProps> = ({ electionName, electionDate, calendarEvent }) => {
    return (
        <Banner data-cy="gotv-next-election">
            <IconWrap aria-hidden="true">
                <i className="fa fa-calendar" />
            </IconWrap>

            <Content>
                <div className="name" data-cy="election-name">
                    {electionName}
                </div>
                <div className="date" data-cy="election-date">
                    {electionDate}
                </div>
            </Content>

            {calendarEvent && (
                <Actions>
                    <AddToCalendar event={calendarEvent} />
                </Actions>
            )}
        </Banner>
    )
}
